import React, { useEffect, useState } from "react";
import { useAuth } from "@/lib/auth";
import { api, BRAND, formatApiError } from "@/lib/api";
import { PageHeader, StatCard } from "@/components/Common";
import { Percent, CheckCircle2, XCircle } from "lucide-react";
import { toast } from "sonner";

export default function MyAttendance() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!user?.student_id) return;
    api.get(`/attendance/student/${user.student_id}`).then(r => setData(r.data))
      .catch(err => toast.error(formatApiError(err)));
  }, [user]);

  return (
    <div data-testid="student-attendance-page">
      <PageHeader eyebrow="Minha frequência" title="Presença" mascot={BRAND.MANGUITA_COACH} />

      <div className="grid grid-cols-3 gap-4 mb-6">
        <StatCard label="Frequência" value={`${data?.percentage ?? 0}%`} icon={Percent} color="lime" />
        <StatCard label="Presenças" value={data?.present ?? 0} icon={CheckCircle2} color="blue" />
        <StatCard label="Aulas totais" value={data?.total ?? 0} icon={XCircle} color="yellow" />
      </div>

      <div className="vv-card">
        <div className="p-4 border-b border-border font-black uppercase tracking-wider text-sm">Histórico</div>
        {(data?.history || []).length === 0 ? (
          <div className="p-6 text-muted-foreground">Sem registros ainda.</div>
        ) : (
          <div className="divide-y divide-border">
            {data.history.map((h, i) => (
              <div key={i} className="p-3 flex items-center justify-between">
                <div className="font-semibold">{h.date}</div>
                <span className={`vv-chip ${h.present ? "vv-chip-lime" : "vv-chip-muted"}`}>
                  {h.present ? "Presente" : "Faltou"}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
